import React, { useState, useEffect } from 'react';
import { apiRequest } from '../../fetchSetup';

const AyujaConfigSettings = () => {
  const [config, setConfig] = useState({ configured_offered_discount_pct: 20, configured_min_profit_pct: 8 });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    apiRequest(process.env.REACT_APP_GET_AYUJA_CONFIG)
      .then(r => r.json())
      .then(data => setConfig(data))
      .catch(console.error);
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await apiRequest(process.env.REACT_APP_GET_AYUJA_CONFIG, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(config)
      });
      const data = await res.json();
      setMessage(data.message || 'Saved');
    } catch (e) {
      setMessage('Error saving');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ background: '#fff',marginLeft:400, borderRadius: 12, padding: 24, maxWidth: 480, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 20 }}>⚙️ AYUJA Pricing Configuration</h2>

      <div style={{ marginBottom: 16 }}>
        <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
          Max Offered Discount % (to customers)
        </label>
        <input
          type="number" min="0" max="100" step="0.5"
          value={config.configured_offered_discount_pct}
          onChange={e => setConfig(p => ({ ...p, configured_offered_discount_pct: parseFloat(e.target.value) }))}
          style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: 8, padding: '10px 12px', fontSize: 16, boxSizing: 'border-box' }}
        />
        <p style={{ fontSize: 11, color: '#6B7280', marginTop: 4 }}>
          Orders will never exceed this discount. AYUJA will also cap by profit protection.
        </p>
      </div>

      <div style={{ marginBottom: 20 }}>
        <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
          Minimum Profit % (on MRP)
        </label>
        <input
          type="number" min="0" max="100" step="0.5"
          value={config.configured_min_profit_pct}
          onChange={e => setConfig(p => ({ ...p, configured_min_profit_pct: parseFloat(e.target.value) }))}
          style={{ width: '100%', border: '1px solid #D1D5DB', borderRadius: 8, padding: '10px 12px', fontSize: 16, boxSizing: 'border-box' }}
        />
        <p style={{ fontSize: 11, color: '#6B7280', marginTop: 4 }}>
          Profit will never go below this percentage even if discount headroom allows.
        </p>
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        style={{ backgroundColor: '#006D77', color: '#fff', border: 'none', borderRadius: 8, padding: '12px 24px', fontSize: 15, fontWeight: 600, cursor: 'pointer', width: '100%' }}
      >
        {saving ? 'Saving...' : 'Save Configuration'}
      </button>

      {message && <p style={{ marginTop: 12, color: '#16a34a', fontSize: 13, fontWeight: 600 }}>{message}</p>}
    </div>
  );
};

export default AyujaConfigSettings;


